<template>
    <input ref="file" type="file" :accept="accept" :multiple="multiple" @change="onChange">
</template>

<script>
    export default {
        name: "FileInput",

        props: {
            accept: {
                type: String,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            onChange() {
                this.$emit('change', this.$refs.file.files);
            },
            openFileDialog() {
                this.$refs.file.value = '';
                this.$refs.file.click();
            }
        }
    }
</script>

<style scoped>

</style>
